window.productHelpers = {
    async getProducts( params = {} ) {
        this.loading = true;
        try {

            const response = await fetch( window.appConfig.routes.getProducts, {
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': window.appConfig.csrfToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(params)
            });

            if (response.ok)
                return await response.json();

            return [];

        } catch (error) {

            throw error;

        }

    }
}